import { c as _c } from "react/compiler-runtime";
import { useState } from "react";

// The individual pixel boxes that make up the "BLACKSMITH" wordmark, in SVG
// user units (viewBox 0 0 152 15). Kept as data (not inline JSX) so each box
// can be revealed on its own for the pixelated build-in animation.
type WordmarkRect = {
  x?: number;
  y?: number;
  width: number;
  height: number;
  transform?: string;
};
const BLACKSMITH_WORDMARK_RECTS: WordmarkRect[] = [{
  x: 59.5264,
  width: 2.36842,
  height: 15
}, {
  x: 61.8948,
  y: 6.31543,
  width: 6.31579,
  height: 2.36842
}, {
  x: 68.0527,
  y: 4.2627,
  width: 2.36842,
  height: 2.21053
}, {
  x: 68.0527,
  y: 8.52637,
  width: 2.36842,
  height: 2.21053
}, {
  x: 70.1052,
  y: 10.5791,
  width: 2.36842,
  height: 4.42105
}, {
  x: 70.1052,
  width: 2.36842,
  height: 4.42105
}, {
  x: 54.7896,
  y: 10.5791,
  width: 2.36842,
  height: 2.36842
}, {
  x: 46.2632,
  width: 8.68421,
  height: 2.36842
}, {
  x: 54.7896,
  y: 2.05273,
  width: 2.36842,
  height: 2.36842
}, {
  x: 44.0527,
  y: 2.05273,
  width: 2.36842,
  height: 10.8947
}, {
  x: 46.2632,
  y: 12.6318,
  width: 8.68421,
  height: 2.36842
}, {
  x: 30.7896,
  width: 8.68421,
  height: 2.36842
}, {
  x: 30.7896,
  y: 6.31543,
  width: 8.68421,
  height: 2.36842
}, {
  x: 28.7368,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  x: 39.3157,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  width: 10.8947,
  height: 2.36842
}, {
  x: 2.05273,
  y: 6.31543,
  width: 8.8421,
  height: 2.36842
}, {
  x: 2.05273,
  y: 12.6318,
  width: 8.8421,
  height: 2.36842
}, {
  y: 15,
  width: 6.63158,
  height: 2.36842,
  transform: "rotate(-90 0 15)"
}, {
  x: 10.5789,
  y: 12.9473,
  width: 4.42105,
  height: 2.36842,
  transform: "rotate(-90 10.5789 12.9473)"
}, {
  x: 10.5789,
  y: 6.47363,
  width: 4.42105,
  height: 2.36842,
  transform: "rotate(-90 10.5789 6.47363)"
}, {
  y: 6.47363,
  width: 4.42105,
  height: 2.36842,
  transform: "rotate(-90 0 6.47363)"
}, {
  x: 15.3157,
  y: 12.6318,
  width: 10.8947,
  height: 2.36842
}, {
  x: 15.3157,
  y: 15,
  width: 15,
  height: 2.36842,
  transform: "rotate(-90 15.3157 15)"
}, {
  x: 77.0527,
  width: 8.8421,
  height: 2.36842
}, {
  x: 75,
  y: 2.05273,
  width: 2.36842,
  height: 4.42105
}, {
  x: 85.5789,
  y: 2.05273,
  width: 2.36842,
  height: 2.36842
}, {
  x: 77.0527,
  y: 6.31543,
  width: 8.8421,
  height: 2.36842
}, {
  x: 85.5789,
  y: 8.52637,
  width: 2.36842,
  height: 4.42105
}, {
  x: 77.0527,
  y: 12.6318,
  width: 8.8421,
  height: 2.36842
}, {
  x: 75,
  y: 10.5791,
  width: 2.36842,
  height: 2.36842
}, {
  x: 90.3157,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  x: 92.5261,
  width: 4.42105,
  height: 2.36842
}, {
  x: 98.842,
  width: 4.57895,
  height: 2.36842
}, {
  x: 96.7893,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  x: 103.105,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  x: 108,
  width: 4.57895,
  height: 2.36842
}, {
  x: 114.316,
  width: 4.57895,
  height: 2.36842
}, {
  x: 108,
  y: 12.6318,
  width: 4.57895,
  height: 2.36842
}, {
  x: 114.316,
  y: 12.6318,
  width: 4.57895,
  height: 2.36842
}, {
  x: 112.263,
  y: 2.05273,
  width: 2.36842,
  height: 10.8947
}, {
  x: 121.263,
  width: 6.63158,
  height: 2.36842
}, {
  x: 127.579,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  x: 129.79,
  width: 6.63158,
  height: 2.36842
}, {
  x: 138.79,
  width: 2.36842,
  height: 15
}, {
  x: 151.737,
  y: 6.1582,
  width: 2.36842,
  height: 12.9474,
  transform: "rotate(90 151.737 6.1582)"
}, {
  x: 149.368,
  width: 2.36842,
  height: 15
}];

// Rightmost x among the boxes; each box's reveal timing is driven by its x
// position so the word writes itself in left-to-right.
const WORDMARK_MAX_X = Math.max(...BLACKSMITH_WORDMARK_RECTS.map(r => r.x ?? 0));
// Stagger window over which boxes start appearing (left-to-right). The last
// boxes land at ~WORDMARK_REVEAL_MS, then fade in over WORDMARK_FADE_IN_MS, so
// the overall build is ~450ms.
const WORDMARK_REVEAL_MS = 410;
// Each box fades in over this window once its staggered delay elapses, softening
// the arrival of the many small boxes so it reads smooth rather than flickery.
const WORDMARK_FADE_IN_MS = 40;
// On close the whole wordmark fades out together (a subtle crossfade to the
// emblem) rather than replaying the pixel build in reverse.
const WORDMARK_FADE_OUT_MS = 100;
// Ease applied to each box's x-driven delay: delay = xNorm^power · REVEAL. A
// power > 1 makes the left-to-right sweep start brisk and gently decelerate as
// it reaches the right edge. (Higher = more deceleration.)
const WORDMARK_EASE_POWER = 1.7;
// Per-box random deviation (fraction of the reveal window), re-rolled each open,
// so the left-to-right sweep isn't a rigid wipe — boxes near each other pop in a
// slightly organic, non-mechanical order.
const WORDMARK_JITTER_FRACTION = 0.12;
// Each box appears one box-length off its final spot, holds there for this brief
// window, then slides into its final position.
const WORDMARK_HOLD_MS = 100;
// Duration of the slide from `offset` to the final position.
const WORDMARK_SLIDE_MS = 100;
// Only the last (rightmost) few boxes slide in from the left; the rest just
// appear in place. Set to 0 to disable sliding entirely.
const WORDMARK_SLIDE_COUNT = 0;
// x cutoff for the rightmost WORDMARK_SLIDE_COUNT boxes (those slide).
const WORDMARK_SLIDE_X_THRESHOLD = [...BLACKSMITH_WORDMARK_RECTS].map(r => r.x ?? 0).sort((a, b) => b - a)[Math.min(WORDMARK_SLIDE_COUNT, BLACKSMITH_WORDMARK_RECTS.length) - 1];
// Fixed leftward distance every sliding box starts from: the average of the
// boxes' smaller dimension (their "thickness"), so the slide reads as roughly
// one stroke width regardless of the box's shape.
const WORDMARK_SLIDE_DISTANCE = BLACKSMITH_WORDMARK_RECTS.reduce((sum, r) => sum + Math.min(r.width, r.height), 0) / BLACKSMITH_WORDMARK_RECTS.length;

// Pixel-font "BLACKSMITH" wordmark. Fills inherit currentColor so it can be
// themed (dark grey in light mode, brand yellow in dark mode) by the caller.
//
// When `expanded` is true the word writes itself in left-to-right: each box's
// delay is driven by its x position (gently eased so the sweep decelerates),
// with a small per-open random jitter so it isn't a rigid wipe. Each box then
// fades in over a short window. A configurable few of the rightmost boxes can
// slide in from the left instead of appearing in place. On close the word fades
// out together (a subtle crossfade to the emblem); pass `instant` to skip that
// fade for navigation-driven closes that snap shut.
export const BlacksmithWordmarkSVG = t0 => {
  const $ = _c(10);
  const {
    className,
    expanded: t1,
    instant: t2,
    animateReveal: t3
  } = t0;
  const expanded = t1 === undefined ? true : t1;
  const instant = t2 === undefined ? false : t2;
  const animateReveal = t3 === undefined ? true : t3;
  const rollReveal = _temp2;
  const [reveal, setReveal] = useState(rollReveal);
  const [wasExpanded, setWasExpanded] = useState(expanded);
  if (expanded !== wasExpanded) {
    setWasExpanded(expanded);
    if (expanded) {
      setReveal(rollReveal());
    }
  }
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      overflow: "visible"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <title>Blacksmith</title>;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== animateReveal || $[3] !== expanded || $[4] !== instant || $[5] !== reveal) {
    t6 = BLACKSMITH_WORDMARK_RECTS.map((r, i) => {
      const jit = reveal[i];
      const xNorm = (r.x ?? 0) / WORDMARK_MAX_X;
      const base = Math.pow(xNorm, WORDMARK_EASE_POWER) * WORDMARK_REVEAL_MS;
      const jitter = (jit - 0.5) * 2 * WORDMARK_REVEAL_MS * WORDMARK_JITTER_FRACTION;
      const delay = expanded ? Math.max(0, base + jitter) : 0;
      const slides = WORDMARK_SLIDE_COUNT > 0 && (r.x ?? 0) >= WORDMARK_SLIDE_X_THRESHOLD;
      const offset = slides ? `translate(${-WORDMARK_SLIDE_DISTANCE}px, 0px)` : "translate(0px, 0px)";
      return <g key={i} style={{
        opacity: expanded ? 1 : 0,
        transform: expanded ? "translate(0px, 0px)" : offset,
        transition: expanded ? animateReveal ? `opacity ${WORDMARK_FADE_IN_MS}ms ease-out ${delay}ms, transform ${WORDMARK_SLIDE_MS}ms ease-out ${delay + WORDMARK_HOLD_MS}ms` : "none" : instant ? "opacity 0ms linear, transform 0ms linear" : `opacity ${WORDMARK_FADE_OUT_MS}ms ease-out, transform 0ms linear`
      }}><rect x={r.x} y={r.y} width={r.width} height={r.height} transform={r.transform} /></g>;
    });
    $[2] = animateReveal;
    $[3] = expanded;
    $[4] = instant;
    $[5] = reveal;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== className || $[8] !== t6) {
    t7 = <svg className={className} width="152" height="15" viewBox="0 0 152 15" fill="currentColor" overflow="visible" style={t4} xmlns="http://www.w3.org/2000/svg">{t5}{t6}</svg>;
    $[7] = className;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
function _temp() {
  return Math.random();
}
function _temp2() {
  return BLACKSMITH_WORDMARK_RECTS.map(_temp);
}